import type { ColumnVisibilityState } from '@tanstack/react-table';

import { mergeColumnVisibility } from '@/utils/columnVisibility';

const DEFAULT_VISIBLE_COLUMNS: ColumnVisibilityState = {
    id: true,
    name: true,
    siteCount: true,
    penCount: true,
    bioscopeCount: true,
    staleBioscopeCount: true,
    lastMeasurement: true,
    contractCount: true,
    licenseStatus: true,
    nextLicenseExpiry: true,
    userCount: true,
    apiUserCount: false,
    integrations: false,
    createdAt: false,
};

export function resolveColumnVisibility(stored: ColumnVisibilityState): ColumnVisibilityState {
    return mergeColumnVisibility(DEFAULT_VISIBLE_COLUMNS, stored);
}

export const COLUMN_VISIBILITY_STORAGE_KEY = 'client-list-column-visibility';
export const PAGE_SIZE_STORAGE_KEY = 'client-list-page-size';
export const DEFAULT_PAGE_SIZE = 15;
export const PAGE_SIZE_OPTIONS = [15, 25, 50, 100];

/** The columns the column menu lists, in table order. The name always shows. */
export const COLUMN_METADATA: Array<{ id: string; header: string }> = [
    { id: 'id', header: 'internal.clients.columns.id' },
    { id: 'siteCount', header: 'internal.clients.columns.sites' },
    { id: 'penCount', header: 'internal.clients.columns.pens' },
    { id: 'bioscopeCount', header: 'internal.clients.columns.bioscopes' },
    { id: 'staleBioscopeCount', header: 'internal.clients.columns.staleBioscopes' },
    { id: 'lastMeasurement', header: 'internal.clients.columns.lastMeasurement' },
    { id: 'contractCount', header: 'internal.clients.columns.contracts' },
    { id: 'licenseStatus', header: 'internal.clients.columns.licenseStatus' },
    { id: 'nextLicenseExpiry', header: 'internal.clients.columns.nextLicenseExpiry' },
    { id: 'userCount', header: 'internal.clients.columns.users' },
    { id: 'apiUserCount', header: 'internal.clients.columns.apiUsers' },
    { id: 'integrations', header: 'internal.clients.columns.integrations' },
    { id: 'createdAt', header: 'internal.clients.columns.createdAt' },
];
